import { render } from "./InputNumber.vue?vue&type=template&id=396e5a3c&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"

import "./InputNumber.vue?vue&type=style&index=0&id=396e5a3c&lang=css"
import "./InputNumber.vue?vue&type=style&index=1&id=396e5a3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396e5a3c"]])

export default __exports__